import { useAppDispatch } from "@/redux/hook";
import { resetWorkflowState } from "@/redux/reducer/workflowSlice";
import { useInvalidateWorkflowsMutation } from "@/services/workflow";
import { useCallback } from "react";

export const useResetWorkflowsData = () => {
  const [invalidateWorkflows] = useInvalidateWorkflowsMutation();
  const appDispatch = useAppDispatch();

  return useCallback(() => {
    // clear cache query
    invalidateWorkflows();

    // clear data in store
    appDispatch(resetWorkflowState());
  }, [appDispatch, invalidateWorkflows]);
};
